import { FC } from 'react';

import { IconProps } from '../types';

export const PaperIcon: FC<IconProps> = ({ size, height = 18, width = 22, color = '#06519E' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 18 22"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M3 22h12c1.654 0 3-1.35 3-3V6.5c0-.26-.105-.52-.293-.71l-5.5-5.5A1.027 1.027 0 0 0 11.5 0H3C1.346 0 0 1.35 0 3v16c0 1.65 1.346 3 3 3Zm7-20H3c-.551 0-1 .45-1 1v16c0 .55.449 1 1 1h12c.552 0 1-.45 1-1V8h-5c-.553 0-1-.45-1-1V2Zm5.086 4H12V2.91L15.086 6Z"
		/>
	</svg>
);
